module.exports = __webpack_public_path__ + "img/pro.c63c3a88.png";